import React from 'react'
import { useRouter } from '../../pages/routes/hooks/use-router'
import useResponsiveStore from '../../store/responsive-store';

const EntryCard = ({item,handleClick,handleOpen}) => {
    const router=useRouter()
    const { responsiveData } = useResponsiveStore();

  return (
    <div onClick={()=>{
      if(item.title=='Upload Images'){
        handleOpen()
      }else{
        handleClick(item.title)
      }
      }} className='k-text-center'>
    <div className={`${responsiveData.isMobile ? 'k-py-4 k-px-10' : 'k-py-8 k-px-16'} k-elevation-1 k-rounded-lg k-cursor-pointer`} style={{color:"#FFFFFF"}}>
        <img height={64} width={64} alt='img' src={item.image}/>
    </div>
  <h2 className='k-font-bold k-mt-5 k-sm-sub-heading'>{item.title}</h2>
  </div>
  )
}

export default EntryCard